import {AddressModel} from './models/core/address';
import {AffiliateModel} from './models/core/affiliate';
import {AnswerModel} from './models/core/answer';
import {AttendeeModel} from './models/core/attendee';
import {BasketModel} from './models/core/basket';
import {BasketItemModel} from './models/core/basket_item';
import {BookableItemModel} from './models/core/bookable_item';
import {BulkPurchaseModel} from './models/core/bulk_purchase';
import {BusinessQuestionModel} from './models/core/business_question';
import {CategoryModel} from './models/core/category';
import {ClientModel} from './models/core/client';
import {ClientDetailsModel} from './models/core/client_details';
import {ClientQueueModel} from './models/core/client_queue';
import {ClinicModel} from './models/core/clinic';
import {CollectionModel} from './models/core/collection';
import {CompanyModel} from './models/core/company';
import {CompanySettingsModel} from './models/core/company_settings';
import {AdminConversationModel} from './models/admin/conversation';
import {DayModel} from './models/core/day';
import {DealModel} from './models/core/deal';
import {DisplayBoardModel} from './models/core/display_board';
import {EventModel} from './models/core/event';
import {EventChainModel} from './models/core/event_chain';
import {EventGroupModel} from './models/core/event_group';
import {EventSequenceModel} from './models/core/event_sequence';
import {EventTicketModel} from './models/core/event_ticket';
import {ExternalPurchaseModel} from './models/core/external_purchase';
import {ImageModel} from './models/core/image';
import {ItemModel} from './models/core/item';
import {ItemDetailsModel} from './models/core/item_details';
import {ItemsModel} from './models/core/items';
import {LoginModel} from './models/core/login';
import {MultiBasketModel} from './models/core/multi_basket';
import {MembershipLevelModel} from './models/core/membership_level';
import {AdminMessageModel} from './models/admin/message';
import {OpeningHoursModel} from './models/core/opening_hours';
import {PackageItemModel} from './models/core/package_item';
import {PaginationModel} from './models/core/paginiation';
import {PaymentCallbacksModel} from './models/core/payment_callbacks';
import {PersonModel} from './models/core/person';
import {PrePaidBookingModel} from './models/core/pre_paid_booking';
import {ProductModel} from './models/core/product';
import {PurchaseItemModel} from './models/core/purchase_item';
import {Purchase_TotalModel} from './models/core/purchase_total';
import {ResourceModel} from './models/core/resource';
import {QuestionModel} from './models/core/question';
import {QueuerModel} from './models/core/queuer';
import {ReasonModel} from './models/core/reason';
import {ServiceModel} from './models/core/service';
import {ServiceItemModel} from './models/core/service_item';
import {SlotModel} from './models/core/slot';
import {SpaceModel} from './models/core/space';
import {SurveyQuestionModel} from './models/core/survey_question';
import {TimeSlotModel} from './models/core/time_slot';

import {AdminAddressModel} from './models/admin/address';
import {AdminAdministratorModel} from './models/admin/administrator';
import {AdminBookingModel} from './models/admin/booking';
import {AdminClientModel} from './models/admin/client';
import {AdminClientQueueModel} from './models/admin/client_queue';
import {AdminClinicModel} from './models/admin/clinic';
import {AdminCompanyModel} from './models/admin/company';
import {AdminEventModel} from './models/admin/event';
import {AdminEventChainModel} from './models/admin/event_chain';
import {AdminEventGroupModel} from './models/admin/event_group';
import {AdminIntegrationModel} from './models/admin/integration';
import {AdminIntegrationImplementationModel} from './models/admin/integration_implementation';
import {AdminLoginModel} from './models/admin/login_model';
import {AdminObjectMappingModel} from './models/admin/object_mapping';
import {AdminPersonModel} from './models/admin/person';
import {AdminOrderModel} from './models/admin/order';
import {AdminQueuerModel} from './models/admin/queuer';
import {AdminResourceModel} from './models/admin/resource';
import {AdminScheduleModel} from './models/admin/schedule';
import {AdminServiceModel} from './models/admin/service';
import {AdminShiftModel} from './models/admin/shift';
import {AdminShiftPatternModel} from './models/admin/shift_pattern';
import {AdminSlotModel} from './models/admin/slot';
import {AdminUserModel} from './models/admin/user';
import {AdminNotificationTriggerModel} from './models/admin/notification_trigger';

import {MemberBookingModel} from './models/member/booking';
import {MemberMemberModel} from './models/member/member';
import {MemberPaymentItemModel} from './models/member/payment_item';
import {MemberPrePaidBookingModel} from './models/member/pre_paid_booking';
import {MemberPurchaseModel} from './models/member/purchase';
import {MemberPurchaseItemModel} from './models/member/purchase_item';
import {MemberWalletModel} from './models/member/wallet';
import {MemberWalletLogModel} from './models/member/wallet_log';
import {MemberWalletPurchaseBandModel} from './models/member/wallet_purchase_band';

import {PurchaseBookingModel} from './models/purchase/booking';
import {PurchaseCourseBookingModel} from './models/purchase/course_booking';
import {PurchaseTotalModel} from './models/purchase/total';

import {SettingsAdministratorModel} from './models/settings/administrator';
import {SettingsUserModel} from './models/settings/user';

import {ConversationModel} from './models/core/conversation';
import {MessageModel} from './models/core/message';
import {BaseModel} from './models/base';

const BBModel = {
    Address: AddressModel,
    Affiliate: AffiliateModel,
    Answer: AnswerModel,
    Attendee: AttendeeModel,
    Base: BaseModel,
    Basket: BasketModel,
    BasketItem: BasketItemModel,
    BookableItem: BookableItemModel,
    BulkPurchase: BulkPurchaseModel,
    BusinessQuestion: BusinessQuestionModel,
    Category: CategoryModel,
    Client: ClientModel,
    ClientDetails: ClientDetailsModel,
    ClientQueue: ClientQueueModel,
    Clinic: ClinicModel,
    Collection: CollectionModel,
    Company: CompanyModel,
    CompanySettings: CompanySettingsModel,
    Conversation: ConversationModel,
    Day: DayModel,
    Deal: DealModel,
    DisplayBoard: DisplayBoardModel,
    Event: EventModel,
    EventChain: EventChainModel,
    EventGroup: EventGroupModel,
    EventSequence: EventSequenceModel,
    EventTicket: EventTicketModel,
    ExternalPurchase: ExternalPurchaseModel,
    Image: ImageModel,
    Item: ItemModel,
    ItemDetails: ItemDetailsModel,
    Items: ItemsModel,
    Login: LoginModel,
    MembershipLevel: MembershipLevelModel,
    Message: MessageModel,
    MultiBasket: MultiBasketModel,
    OpeningHours: OpeningHoursModel,
    PackageItem: PackageItemModel,
    Pagination: PaginationModel,
    PaymentCallbacks: PaymentCallbacksModel,
    Person: PersonModel,
    PrePaidBooking: PrePaidBookingModel,
    Product: ProductModel,
    PurchaseItem: PurchaseItemModel,
    PurchaseTotal: Purchase_TotalModel,
    Resource: ResourceModel,
    Question: QuestionModel,
    Queuer: QueuerModel,
    Reason: ReasonModel,
    Service: ServiceModel,
    ServiceItem: ServiceItemModel,
    Slot: SlotModel,
    Space: SpaceModel,
    SurveyQuestion: SurveyQuestionModel,
    TimeSlot: TimeSlotModel,

    Admin: {
        Address: AdminAddressModel,
        Administrator: AdminAdministratorModel,
        Booking: AdminBookingModel,
        Client: AdminClientModel,
        ClientQueue: AdminClientQueueModel,
        Clinic: AdminClinicModel,
        Company: AdminCompanyModel,
        Conversation: AdminConversationModel,
        Event: AdminEventModel,
        EventChain: AdminEventChainModel,
        EventGroup: AdminEventGroupModel,
        Integration: AdminIntegrationModel,
        IntegrationImplementation: AdminIntegrationImplementationModel,
        Login: AdminLoginModel,
        Message: AdminMessageModel,
        ObjectMapping: AdminObjectMappingModel,
        Person: AdminPersonModel,
        Order: AdminOrderModel,
        Queuer: AdminQueuerModel,
        Resource: AdminResourceModel,
        Schedule: AdminScheduleModel,
        Service: AdminServiceModel,
        Shift: AdminShiftModel,
        ShiftPattern: AdminShiftPatternModel,
        Slot: AdminSlotModel,
        User: AdminUserModel,
        NotificationTrigger: AdminNotificationTriggerModel
    },
    Member: {
        Booking: MemberBookingModel,
        Member: MemberMemberModel,
        PaymentItem: MemberPaymentItemModel,
        PrePaidBooking: MemberPrePaidBookingModel,
        Purchase: MemberPurchaseModel,
        PurchaseItem: MemberPurchaseItemModel,
        Wallet: MemberWalletModel,
        WalletLog: MemberWalletLogModel,
        WalletPurchaseBand: MemberWalletPurchaseBandModel
    },
    Purchase: {
        Booking: PurchaseBookingModel,
        CourseBooking: PurchaseCourseBookingModel,
        Total: PurchaseTotalModel
    },
    Settings: {
        Administrator: SettingsAdministratorModel,
        User: SettingsUserModel
    }
};

export {
    BBModel
};
